<script setup lang="ts">
  import { createElementId } from '@common/core-layer/utils/core.utils'

  import CPSkeleton from '@ui/components/CPSkeleton.vue'
</script>

<template>
  <div
    :id="createElementId('search', 'loading', 'container')"
    class="w-full"
  >
    <!-- Courses Section Skeleton -->
    <div class="mb-6">
      <!-- Section Header Skeleton -->
      <div class="px-4 py-3">
        <CPSkeleton
          type="text"
          width="60px"
          height="14px"
          :round="false"
        />
      </div>

      <!-- Horizontal Course Cards Skeleton -->
      <div class="overflow-x-hidden">
        <div class="flex gap-4 px-4 pb-4">
          <!-- Course Card 1 -->
          <CPSkeleton
            type="image"
            height="110px"
            :round="false"
          />

          <!-- Course Card 2 -->
          <CPSkeleton
            type="image"
            height="110px"
            :round="false"
          />
        </div>
      </div>
    </div>

    <!-- Lessons Section Skeleton -->
    <div>
      <!-- Section Header Skeleton -->
      <div class="px-4 py-3">
        <CPSkeleton
          type="text"
          width="60px"
          height="14px"
          :round="false"
        />
      </div>

      <!-- Vertical Lesson Items Skeleton -->
      <div class="space-y-0">
        <div
          v-for="i in 2"
          :key="`lesson-skeleton-${i}`"
          class="flex items-center gap-2 px-4 mb-2"
        >
          <!-- Lesson Number -->
          <CPSkeleton
            type="text"
            width="100%"
            height="50px"
            :round="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>
